$(document).ready(function () {
    $('a.suche').click(function () {
        $('.mod_search.header-search').toggleClass('active');
        event.preventDefault();
    });
});
